<template>
  <layout>
    <template v-slot:header>
      <AppHead title="Sales" />
      <div class="d-flex align-items-center">
        <h2 class="m-0">Sales</h2>
        <jet-button class="btn-short ml-2" :goesTo="route('admin.sales.create')" icon="fas fa-plus">Create Sale</jet-button>
      </div>
      <BreadCrumbs activeItem="Sales" :crumbs="{ home: 'Dashboard'}"/>
      <flash-messages />
    </template>
    
    <template v-slot:default>
      <DataTable ref="admin-sales-index"
        :value="sales" :paginator="true" :rows="100" 
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" currentPageReportTemplate="({first} - {last} of {totalRecords})"
        paginatorPosition="both" removableSort
        :rowsPerPageOptions="[10, 20, 50, 100]" 
        sortField="date" :sortOrder="-1" 
        stateStorage="local" stateKey="admin-sales-index" dataKey="id" breakpoint="992px"
        :rowClass="() => { return 'table-row' }"
        class="p-datatable-sm admin-datatable thead-ui" 
        @row-click="(e) => $inertia.get(route('admin.sales.view', e.data.id))">
          <template #paginatorLeft>
            {{ sales.length }} Sales
          </template>
          <Column field="id" header="ID"></Column>
          <Column field="title" header="Title" :sortable="true"></Column>
          <Column field="active" header="Active" :sortable="true">
            <template #body="slotProps">
              <span :class="[slotProps.data.active ? 'text-success' : 'text-danger' ]">{{ slotProps.data.active ?  'Active' : 'Inactive' }}</span> 
            </template>
          </Column>
          <Column field="revenue" header="Revenue" :sortable="true">
            <template #body="slotProps">
              {{ formatDollars(slotProps.data.revenue) }}
            </template>
          </Column>
          <Column field="start_at" header="Start" :sortable="true">
            <template #body="slotProps">
              {{ moment(slotProps.data.start_at).format('M/D/YY h:mm A') }}
            </template>
          </Column>
          <Column field="end_at" header="End" :sortable="true">
            <template #body="slotProps">
              {{ moment(slotProps.data.end_at).format('M/D/YY h:mm A') }}
            </template>
          </Column>
          <Column field="created_at" header="Created" :sortable="true">
            <template #body="slotProps">
              {{ moment(slotProps.data.created_at).format('M/D/YY h:mm A') }}
            </template>
          </Column>
          <Column class="button-container" :exportable="false">
            <template #body="slotProps">
              <jet-button class="nav-icon btn-short" :goesTo="route('admin.sales.view', slotProps.data.id)" icon="fas fa-chevron-right">View</jet-button>
            </template>
          </Column>
      </DataTable>
    </template>
  </layout>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Admin/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import FlashMessages from '@/Shared/FlashMessages'
import BreadCrumbs from '@/Shared/BreadCrumbs'

import Calendar from 'primevue/calendar';

import moment from 'moment'

export default {
  components: {
    Icon,
    SearchFilter,
    Layout,
    FlashMessages,
    BreadCrumbs,
    Calendar,
  },
  props: {
    sales: Array,
  },
  data() {
    return {
      form: {
      },
    }
  },
  created() {
    this.moment = moment;
  },
  mounted() {
  },
  methods: {
  },
}
</script>
